module.exports = __webpack_public_path__ + "img/brand-type3.7537afa0.svg";